import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow, IconButton } from "@similarweb/ui-components";

const { carbon, sky } = colorsPalettes;

export const TopicsContainer = styled(FlexColumn)`
    width: 100%;
`;

export const TopicHeader = styled(FlexRow)`
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

const SubTitle = styled(FlexRow)`
    ${setFontVariant("subtitle2", carbon[400])};
    gap: 8px;
    margin: 0 0 16px;
`;

export const TopicsBody = styled(FlexColumn)`
    align-items: center;
    gap: 8px;
    position: relative;

    background: ${sky[100]};
    border-radius: 6px;
    padding: 0 8px 8px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
`;

export const FilterContainer = styled(FlexRow)`
    box-sizing: border-box;
    justify-content: space-between;
    gap: 8px;
`;

const ButtonGroup = styled(FlexRow)`
    gap: 16px;
    margin-left: auto;

    button {
        padding: 8px 16px;
    }
`;

const Number = styled(FlexRow)`
    ${setFontVariant("input2", carbon[250])};

    align-items: center;
`;

const TitleContainer = styled(FlexRow)`
    gap: 16px;
    align-items: center;
`;

const SuggestionSubtitle = styled(FlexRow)`
    gap: 8px;
    align-items: center;
    ${setFontVariant("subtitle2", carbon[400])};
`;

const TopicIcon = styled(IconButton)`
    & svg {
        width: 10px;
        height: 10px;
    }

    .SWReactIcons {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const PopupWrapper = styled.div`
    position: relative;
`;
